module.exports = __webpack_public_path__ + "static/media/mail-off.2fa9cccf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/mail-off.svg
// module id = 781
// module chunks = 0